import {environment} from "../../../../apps/frontend/src/environments/environment"
import {ElementRef, Injectable} from '@angular/core'
import {logger} from 'nx/src/utils/logger'
import {Library, Loader, LoaderOptions} from '@googlemaps/js-api-loader'
import {map, Observable} from 'rxjs'
import {HttpClient} from '@angular/common/http'
import {GeoDirectionsRequest, MapConfig, MapSearchResult, MapType} from "../../../domain/src/lib/map.model"


@Injectable({
  providedIn: 'root',
})
export class MapService {
  private readonly apiKey!: string
  private readonly libraries = ['routes']
  private readonly version = 'weekly'
  private readonly loader!: Loader
  private response!: google.maps.DirectionsResult


  constructor(
      private readonly http: HttpClient,
  ) {
    this.apiKey = environment.gmaAPIKey
    const loaderOptions: LoaderOptions = {
      apiKey: this.apiKey,
      version: this.version,
      libraries: this.libraries as Library[],
    }
    this.loader = new Loader(loaderOptions)
  }


  initMap(mapType: MapType, config: MapConfig) {
    this.loadMap()?.then(() => {
      switch (mapType) {
        case MapType.PLACES:
          this.initPlacesMap(
              config.htmlRef,
              {lat: 47.167541, lng: 8.292419},
          )
          break
        case MapType.ROUTES:
          this.initRoutesMap(
              config.htmlRef,
              config.origin,
              config.destination,
              config.departureTime,
          )
          break
        default:
          logger.error(`Not yet implemented MapType: ${mapType}`)
          break
      }
    })
  }


  findPlace(query: string): Observable<MapSearchResult> {
    // curl -L -X GET 'https://maps.googleapis.com/maps/api/place/findplacefromtext/json?input=Musem%20of%20Contemporary%20Art%20Australia&inputtype=textquery&fields=place_id,geometry,formatted_address&key=AIzaSyCtqjzNjMTTMlWUvOO-bGQHI1bAFYD3OqA'
    const url = `${environment.apiUrl}/maps/find`
    // const url = `https://maps.googleapis.com/maps/api/place/findplacefromtext/json?input=${htmlQuery}&inputtype=textquery&fields=place_id,geometry,formatted_address&key=${apiKey}`
    // const url: string = 'http://localhost:4200/api/v1/maps/find'
    // const htmlQuery = 'Musem%20of%20Contemporary%20Art%20Australia'
    // const apiKey = this.apiKey
    // const encUrl = this.encodeURL(url, query)
    // const encUrl = `${url}/${htmlQuery}`
    const encUrl = `${url}/${query}`
    // return this.http.get<MapSearchResult>(encUrl)
    // const res = this.http.get<MapSearchResult>(encUrl).pipe(
    // const res = this.http.get<any>(encUrl).pipe(
    return this.http.get<MapSearchResult>(encUrl).pipe(
        map(value => {
          if (value?.formatted_address) {
            value.formatted_address = value.formatted_address.replace(', Switzerland', '')
          }
          return value
        }),
    )
  }


  // TODO: convert to prototype
  private convertToDate(dateTime: Date | string | undefined): Date {
    let res: Date
    switch (typeof dateTime) {
      case 'string': {
        res = new Date(dateTime)
        break
      }
      case 'undefined': {
        res = new Date()
        break
      }
      default: {
        res = new Date()
        break
      }
    }
    const now = new Date()
    return (res < now) ? now : res
  }


  private initRoutesMap(
      htmlRef: ElementRef,
      origin: string | google.maps.LatLng | google.maps.Place | google.maps.LatLngLiteral,
      destination: string | google.maps.LatLng | google.maps.Place | google.maps.LatLngLiteral,
      departureTime: Date | string | undefined,
      avoidHighways = false,
  ): google.maps.DirectionsResult {
    const mapOptions: google.maps.MapOptions = {
      center: {lat: 47.1674397, lng: 8.2886437},
      zoom: 20,
      streetViewControl: false,
    }

    const drivingOptions: google.maps.DrivingOptions = {
      departureTime: this.convertToDate(departureTime),
    }
    const request: google.maps.DirectionsRequest = {
      origin: origin,
      destination: destination,
      travelMode: google.maps.TravelMode.DRIVING,
      drivingOptions: drivingOptions,
      unitSystem: google.maps.UnitSystem.METRIC,
      optimizeWaypoints: true,
      provideRouteAlternatives: true,
      avoidHighways: avoidHighways,
      language: 'de',
      region: 'ch',
    }

    const map = new google.maps.Map(
        htmlRef.nativeElement,
        mapOptions,
    )

    const service = new google.maps.DirectionsService()
    const renderer = new google.maps.DirectionsRenderer()

    renderer.setMap(map)
    service.route(request)
           .then((response) => {
             this.response = response
             renderer.setDirections(response)
           })
           .catch((ex) => {
             globalThis.alert(`GMaps Fehler: ${ex.message}`)
           })
    return this.response
  }


  private initPlacesMap(
      htmlRef: ElementRef,
      center: google.maps.LatLngLiteral,
      zoom: number = 13,  // places
  ) {
    /*
    const mapOptions: google.maps.MapOptions = {
      center: center,
      zoom: zoom,
    }
    const map = new google.maps.Map(
        htmlRef.nativeElement,
        mapOptions,
    )
     */
  }


  private loadMap() {
    if (this.loader === undefined) {
      logger.error('Loader is not initialized!')
      return
    }
    return this.loader.load()
  }


  private encodeURL(url: string, query: string): string {
    const encodedQuery: string = encodeURIComponent(query)
    return `${url}/${encodedQuery}`
  }


  formatAddress(address: string): Observable<string> {
    const url = `${environment.apiUrl}/geocodings/format-address/${address}`
    return this.http.get(url, {responseType: 'text'})
  }


  coordinates(origin: string, destination: string, departureAt?: string): Observable<any> {
    const url = `${environment.apiUrl}/geocodings/coordinates`
    const request = {
      origin: origin,
      destination: destination,
      departureAt: departureAt,
    } as GeoDirectionsRequest
    return this.http.post(url, request).pipe(
        map(value => {
          return value
        }),
    )
  }


  place(address: string): Observable<any> {
    const url = `${environment.apiUrl}/geocodings/place/${address}`
    return this.http.get(url).pipe(
        map(value => {
          return value
        }),
    )
  }
}
